import React from "react";

const errorMessage = ({message}) =>
<div className="form-error-messages">
  {message}
</div>

export default errorMessage
